import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useEntityList, createEntity, deleteEntity } from '../data/entities';

// Pipeline list: create, open in the editor, delete. The graphs themselves
// live in the editor (pages/PipelineEditor.js); the copilot's build_pipeline
// composer creates docs in this same collection.
export default function Pipelines() {
  const navigate = useNavigate();
  const { docs: pipelines, error } = useEntityList('pipeline', {});
  const { docs: pending } = useEntityList('reviewItem', {});
  const [name, setName] = useState('');
  const [busy, setBusy] = useState(false);
  const pendingCount = (pending || []).filter((r) => r.status === 'pending').length;

  const create = async (e) => {
    e.preventDefault();
    if (!name.trim() || busy) return;
    setBusy(true);
    try {
      const id = await createEntity('pipeline', {}, { name: name.trim() });
      setName('');
      navigate(`/pipelines/${id}`);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="cs-page">
      <div style={{ display: 'flex', alignItems: 'baseline', gap: 12, flexWrap: 'wrap' }}>
        <h1 style={{ margin: 0 }}>Pipelines</h1>
        <span style={{ flex: 1 }} />
        <Link to="/review" className="cs-btn cs-btn-outline cs-btn-sm">
          Review queue{pendingCount > 0 ? ` (${pendingCount})` : ''}
        </Link>
      </div>
      <p className="cs-help">
        Chain AI steps into a pipeline you can run on your files. Anything an AI step wants to send
        outside (a webhook, an email) has to pass a review or keyword check first — that gate is enforced,
        not optional.
      </p>

      <form onSubmit={create} style={{ display: 'flex', gap: 8, margin: '14px 0' }}>
        <input
          className="cs-input"
          style={{ maxWidth: 320 }}
          placeholder="New pipeline name"
          value={name}
          onChange={(e) => setName(e.target.value)}
        />
        <button className="cs-btn cs-btn-primary cs-btn-sm" type="submit" disabled={!name.trim() || busy}>
          Create
        </button>
      </form>

      {error && <p className="cs-help" style={{ color: 'var(--danger, #e5484d)' }}>{error}</p>}
      {pipelines === null && <p className="cs-help">Loading…</p>}
      {pipelines?.length === 0 && (
        <div className="cs-empty">
          No pipelines yet. Name one above to open the editor, or describe what you want to the copilot
          (◈ in the corner) and it will build the first draft for you.
        </div>
      )}
      <div style={{ display: 'grid', gap: 10 }}>
        {(pipelines || []).map((p) => (
          <div key={p.id} className="cs-card" style={{ padding: 14, display: 'flex', alignItems: 'center', gap: 12 }}>
            <div style={{ minWidth: 0 }}>
              <Link to={`/pipelines/${p.id}`} style={{ fontWeight: 600 }}>{p.name}</Link>
              <p className="cs-help" style={{ margin: '4px 0 0', fontSize: 12 }}>
                {(p.graph?.blocks || []).length} blocks · {(p.capabilities || []).length} capabilities
                {p.lastRun?.status ? ` · last run ${p.lastRun.status}` : ''}
              </p>
            </div>
            <span style={{ flex: 1 }} />
            <button
              className="cs-btn cs-btn-outline cs-btn-sm"
              onClick={() => {
                if (window.confirm(`Delete pipeline "${p.name}"?`)) deleteEntity('pipeline', {}, p.id);
              }}
            >
              Delete
            </button>
          </div>
        ))}
      </div>
    </div>
  );
}
